import { css } from 'aphrodite';
import { AlarmClockIcon } from '../../../../components/svgs/icons/AlarmClockIcon';
import { styleSheet } from './styles';

export const PendingHistory = ({ title, children }: { title: string; children: React.ReactNode }) => (
	<div className={css(styleSheet.pending)}>
		<AlarmClockIcon aria-hidden='true' className={css(styleSheet.pendingIcon)} />
		<div>
			<p className={css(styleSheet.pendingTitle)}>{title}</p>
			<p className={css(styleSheet.pendingText)}>{children}</p>
		</div>
	</div>
);
